import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import styleNames from "./icon.local.css";

const cx = classNames.bind(styleNames);

/** Icons not yet in MDI webfont 2.1.19 (see docs/UPGRADE.md). Paths from @mdi/js. */
const SVG_ICON_PATHS = {
  radar:
    "M19.07,4.93L17.66,6.34C19.1,7.79 20,9.79 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12C4,7.92 7.05,4.56 11,4.07V6.09C8.16,6.57 6,9.03 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12C18,10.34 17.33,8.84 16.24,7.76L14.83,9.17C15.55,9.9 16,10.9 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12C8,10.14 9.28,8.59 11,8.14V10.28C10.4,10.63 10,11.26 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12C14,11.26 13.6,10.62 13,10.28V2H12A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,9.24 20.88,6.74 19.07,4.93Z",
  "file-lock-outline":
    "M18 13C16.6 13 15.2 14.1 15.2 15.5V17C14.6 17 14 17.6 14 18.2V21.7C14 22.4 14.6 23 15.2 23H20.7C21.4 23 22 22.4 22 21.8V18.3C22 17.6 21.4 17 20.8 17V15.5C20.8 14.1 19.4 13 18 13M18 14.2C18.8 14.2 19.5 14.7 19.5 15.5V17H16.5V15.5C16.5 14.7 17.2 14.2 18 14.2M6 2C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H12V20H6V4H13V9H18V11C18.7 11 19.4 11.2 20 11.4V8L14 2H6Z",
  "monitor-dashboard":
    "M21,16V4H3V16H21M21,2A2,2 0 0,1 23,4V16A2,2 0 0,1 21,18H14V20H16V22H8V20H10V18H3C1.89,18 1,17.1 1,16V4C1,2.89 1.89,2 3,2H21M5,6H14V11H5V6M15,6H19V8H15V6M19,9V14H15V9H19M5,12H9V14H5V12M10,12H14V14H10V12Z"
};

const ICON_PX = {
  xs: 14,
  sm: 20,
  md: 20,
  lg: 24
};

const Icon = ({ name, className, size, ...otherProps }) => {
  const svgPath = SVG_ICON_PATHS[name];

  if (svgPath) {
    const px = ICON_PX[size] || ICON_PX.md;
    return (
      <svg
        className={className}
        width={px}
        height={px}
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...otherProps}
      >
        <path d={svgPath} />
      </svg>
    );
  }

  return (
    <span
      className={cx(
        "mdi",
        `mdi-${name}`,
        "test",
        `ci-icon-size-${size}`,
        className
      )}
      {...otherProps}
    />
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  spin: PropTypes.bool,
  size: PropTypes.oneOf(["lg", "md", "sm", "xs"])
};

Icon.defaultProps = {
  size: "md"
};

export default Icon;
